module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.698 17.18l-4.644 6.252c-.58.8-1.526.728-2.108-.072L10.3 17.214c-.582-.802-.296-1.214.636-1.214H14V8.996A.997.997 0 0 1 15 8h2c.552 0 1 .444 1 .996V16h3.064c.932 0 1.216.378.634 1.18z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-circle-3.js
// module id = 1112
// module chunks = 14